import React from 'react';
import { useTranslation } from 'react-i18next';
import Lottie from "lottie-react";

// Nova animação Lottie central
import coreDefenseAnimation from '../assets/lottie-core-defense.json';

// Ícones menores para acompanhar os títulos
const ShieldIcon = () => <svg className="h-7 w-7 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 20.944a11.955 11.955 0 0118 0 12.02 12.02 0 00-2.382-8.984z"></path></svg>;
const LockIcon = () => <svg className="h-7 w-7 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"></path></svg>;
const ChartIcon = () => <svg className="h-7 w-7 text-accent flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"></path></svg>;

const WhyCrucial = () => {
  const { t } = useTranslation();

  const benefits = [
    { icon: <ShieldIcon />, title: t('crucial_benefit1_title'), description: t('crucial_benefit1_desc'), aos_delay: "200" },
    { icon: <LockIcon />, title: t('crucial_benefit2_title'), description: t('crucial_benefit2_desc'), aos_delay: "400" },
    { icon: <ChartIcon />, title: t('crucial_benefit3_title'), description: t('crucial_benefit3_desc'), aos_delay: "600" }
  ];

  return (
    <section id="why-crucial" className="py-20 bg-blueprint-bg overflow-hidden">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 text-white" data-aos="fade-up">{t('crucial_main_title')}</h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto" data-aos="fade-up" data-aos-delay="200">{t('crucial_main_subtitle')}</p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-16 items-center">
          {/* Coluna Esquerda: Animação Lottie */}
          <div className="flex justify-center" data-aos="zoom-in">
             <div className="w-full max-w-md">
                <Lottie animationData={coreDefenseAnimation} loop={true} />
             </div>
          </div>

          {/* Coluna Direita: Cards de Benefícios */}
          <div className="space-y-8">
            {benefits.map((benefit, index) => (
              <div key={index} data-aos="fade-left" data-aos-delay={benefit.aos_delay}>
                <div className="flex items-start">
                  <div className="bg-primary p-3 rounded-full mr-5">
                    {benefit.icon}
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-2">{benefit.title}</h3>
                    <p className="text-gray-400">{benefit.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyCrucial;